// Action enums
export enum ActionTypes {
  GET_NOTIFICATIONS = "GET_NOTIFICATIONS",
  SET_NOTIFICATION_AS_READ = "SET_NOTIFICATION_AS_READ",
  SET_ALL_NOTIFICATIONS_AS_READ = "SET_ALL_NOTIFICATIONS_AS_READ",
}
